export default "__VITE_ASSET__0bc152b2__"